import Phaser from 'phaser';
import { TopBar } from './components/TopBar';
import { ControlPanel } from './components/ControlPanel';
import { Logo } from './components/Logo';

export abstract class BaseScene extends Phaser.Scene {
  protected screenWidth = 750;
  protected screenHeight = 1334;

  private readonly sceneName;
  private readonly showLogo;
  private logo;

  protected constructor(sceneName: string, showLogo = false) {
    super(sceneName);
    this.sceneName = sceneName;
    this.showLogo = showLogo;
  }
  private backgroundColor = '#000000';
  create() {
    console.log(`*****${this.sceneName}*****`);
    this.cameras.main.setBackgroundColor('#000000');
    this.createBackground();

    if (this.showLogo) {
      this.addLogo();
    }

    this.createHeader();
    this.createBody();
    this.createFooter();

    // Change default sound behavior when the scene blur
    this.sound.pauseOnBlur = false;

    this.game.events.on('blur', () => {
      this.sound.mute = true;
    });

    this.game.events.on('focus', () => {
      this.sound.mute = false;
    });

    this.events.on('shutdown', () => {
      this.stop();
    });
  }

  protected stop() {}

  protected createBackground() {
    const background = this.add.image(this.screenWidth / 2, this.screenHeight / 2, 'background');
    background.setDisplaySize(this.screenWidth, this.screenHeight);
  }

  protected getLogo() {
    return this.logo;
  }

  protected createHeader() {
    new TopBar(this);
  }

  protected abstract createBody();

  protected createFooter() {
    new ControlPanel(this, this.screenWidth, this.screenHeight);
  }

  protected pauseTimer() {
    this.tweens.pauseAll();
    this.sound.pauseAll();
    this.anims.pauseAll();
    this.time.paused = true;
  }

  protected resumeTimer() {
    this.tweens.resumeAll();
    this.sound.resumeAll();
    this.anims.resumeAll();
    this.time.paused = false;
  }

  protected addLogo() {
    this.logo = new Logo(this, this.screenWidth / 2, this.screenHeight * 0.3, 'ttwlogo');
  }

  protected getBackgroundColor() {
    return this.backgroundColor;
  }
  protected setBackgroundColor(bgColor: string) {
    this.backgroundColor = bgColor;
  }
}
